import React from "react"
import propTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import CashRetreat from "./cash-retreat"

const ModalCashRetreat = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Retiro de efectivo
      </ModalHeader>
      <ModalBody>
        <CashRetreat/>
      </ModalBody>
    </Modal>
  )
}

ModalCashRetreat.propTypes = {
  isOpen: propTypes.bool,
  toggle: propTypes.func,
}

export default ModalCashRetreat
